import React from "react";
import { Grid } from "@material-ui/core";
import { FAQList } from "~/components/blocks";
import { Margin } from "~/components/elements";
import isMobile from "~/hooks/isMobile";

import * as S from "./styles";

export default function FAQContent({limit}) {
  const mobile = isMobile();

  return (
    <S.BgBackground>
      <section id="duvidas-frequentes">
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Margin mt={1} mb={2}>
              <S.FAQTitle>Perguntas frequentes</S.FAQTitle>
            </Margin>
            <Margin mb={mobile ? 5 : 9 }>
              <FAQList limit={limit} />
            </Margin>
          </Grid>
        </Grid>
      </section>
    </S.BgBackground>
  );
}
